import React from 'react';
import { Switch } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import {
  getAllSchoolAsync,
  postStatusFeaturedSchoolAsync,
} from './FeaturedSchoolStore/FeaturedSchoolSlice';

export const Column = [
  { Header: 'School Id', accessor: '_id' },
  { Header: 'School Name', accessor: 'schoolName' },
  { Header: 'City', accessor: 'city' },
  {
    Header: 'Status',
    accessor: 'status',
    Cell: (val) => {
      const payload = val.cell.row.original;
      const { _id, isFeatured } = payload;
      const dispatch = useDispatch();

      const fetchData = async () => {
        try {
          dispatch(getAllSchoolAsync({}))
            .unwrap()
            .then(() => {
              toast.success('All Schools were fetched successfully!');
            });
        } catch (error) {
          toast.error(
            'Featured School could not be fetched. Please try again!'
          );
        }
      };

      const handleUpdateOfferStatus = async () => {
        try {
          let payload = {
            schoolId: _id,
            isFeatured: isFeatured === false ? true : true ? false : false,
          };
          dispatch(
            postStatusFeaturedSchoolAsync({
              bodyData: payload,
            })
          )
            .unwrap()
            .then((res) => {
              toast.success(`Featured School has been updated successully!`);
              fetchData();
            });
        } catch (error) {
          toast.error('Featured School not updated!');
        }
      };

      return (
        <Switch
          checked={isFeatured}
          onChange={() => handleUpdateOfferStatus()}
          name="loading"
          color="primary"
        />
      );
    },
  },
];
